import { render, staticRenderFns } from "./Footbowl.vue?vue&type=template&id=58fcbb1b&scoped=true&"
import script from "./Footbowl.vue?vue&type=script&lang=ts&"
export * from "./Footbowl.vue?vue&type=script&lang=ts&"
import style0 from "./Footbowl.vue?vue&type=style&index=0&id=58fcbb1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fcbb1b",
  null
  
)

component.options.__file = "Footbowl.vue"
export default component.exports